import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ContractResponse } from '../../../../../api';
import { BaseRolesService } from '../../../../core/services/base-roles.service';
import { BaseSigningStatus } from '../../_enums/base-signing-status.enum';

@Component({
  selector: 'base-sign-contract-animated-status-button',
  templateUrl: './base-sign-contract-animated-status-button.component.html',
})
export class BaseSignContractAnimatedStatusButtonComponent implements OnInit, OnChanges {
  @Input() contract: ContractResponse;

  isPsp: boolean;

  contractSignedByCustomer: string;
  contractSignedAtCustomer: string;
  contractSignedByPSP: string;
  contractSignedAtPSP: string;
  pspSignatureError: boolean;
  customerSignatureError: boolean;
  isInAQueue: boolean;
  isErrorBorder: boolean;
  isWarningBorder: boolean;

  constructor(private rolesService: BaseRolesService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.contract && !changes.contract.firstChange) {
      this.setSignatureStatusProperties();
    }
  }

  ngOnInit() {
    this.isPsp = this.rolesService.isPsp();
    this.setSignatureStatusProperties();
  }

  private setSignatureStatusProperties(): void {
    this.pspSignatureError = this.contract.signatures?.statusPsp === BaseSigningStatus.error;
    this.customerSignatureError = this.contract.signatures?.statusCustomer === BaseSigningStatus.error;

    this.isInAQueue =
      (this.isPsp && this.contract.signatures?.statusPsp === BaseSigningStatus.in_queue) ||
      (!this.isPsp && this.contract.signatures?.statusCustomer === BaseSigningStatus.in_queue);

    this.contractSignedByCustomer = this.customerSignatureError
      ? `${this.contract.signedByCustomerUser?.firstName} ${this.contract.signedByCustomerUser?.lastName}`
      : '';
    this.contractSignedAtCustomer = this.customerSignatureError ? (this.contract.signedAtCustomer as string) : '';

    this.contractSignedByPSP = this.pspSignatureError
      ? `${this.contract.signedByPspUser?.firstName} ${this.contract.signedByPspUser?.lastName}`
      : '';
    this.contractSignedAtPSP = this.pspSignatureError ? (this.contract.signedAtPSP as string) : '';

    this.isErrorBorder =
      (this.isPsp &&
        (this.pspSignatureError ||
          (this.contract.signatures?.statusPsp === BaseSigningStatus.unsigned && this.customerSignatureError))) ||
      (!this.isPsp &&
        (this.customerSignatureError ||
          (this.contract.signatures?.statusCustomer === BaseSigningStatus.unsigned && this.pspSignatureError)));

    this.isWarningBorder =
      (this.isPsp && this.contract.signatures?.statusPsp === BaseSigningStatus.signed && this.customerSignatureError) ||
      (!this.isPsp && this.contract.signatures?.statusCustomer === BaseSigningStatus.signed && this.pspSignatureError);
  }
}
